import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App.vue'
import VueTheMask from 'vue-the-mask'
import BootstrapVue from 'bootstrap-vue'
import * as VueGoogleMaps from "vue2-google-maps";
import * as GmapVue from 'gmap-vue'
import firebase from 'firebase';
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'vue-multiselect/dist/vue-multiselect.min.css'

import Multiselect from 'vue-multiselect'

// register globally
Vue.component('multiselect', Multiselect)

Vue.use(VueTheMask)
Vue.use(BootstrapVue)
Vue.config.productionTip = false

firebase.initializeApp({
  apiKey: "AIzaSyB1BlmoJuLALeJET5EsSSSzvSoiHv-hxcc",
  authDomain: "k-9-forms.firebaseapp.com",
  databaseURL: "https://k-9-forms.firebaseio.com",
  projectId: "k-9-forms",
  storageBucket: "k-9-forms.appspot.com",
  messagingSenderId: "359456317079",
  appId: "1:359456317079:web:26350bea7fe39cf20b13d2",
  measurementId: "G-MFG19HZVKN"
});
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyBCan97MC8P5xbKGR8WhWb9R4ifuFnsdws",
  }
});


Vue.use(GmapVue, {
  load: {
    key: "AIzaSyBCan97MC8P5xbKGR8WhWb9R4ifuFnsdws",
    libraries: 'places', // This is required if you use the Autocomplete plugin
  },

  //// If you intend to programmatically custom event listener code
  //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  //// you might need to turn this on.
  // autobindAllEvents: false,

  //// If you want to manually install components, e.g.
  //// import {GmapMarker} from 'gmap-vue/src/components/marker'
  //// Vue.component('GmapMarker', GmapMarker)
  //// then set installComponents to 'false'.
  //// If you want to automatically install all the components this property must be set to 'true':
  installComponents: true
})
Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [],
});

new Vue({
  router,
  el: '#app',
  render: h => h(App),
});
